import React from 'react';
import {
  Breadcrumb, useLocation, map, useTranslation, camelCase, contractorService,
} from '@lib/index';

const BreadCrumb = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.slice(1).split('/');
  const contractorPathIndex = paths.indexOf('contractors');
  const contractorIdPathIndex = contractorPathIndex >= 0
    ? contractorPathIndex + 1
    : undefined;
  const contractorIdPath = contractorIdPathIndex ? paths[contractorIdPathIndex] : undefined;
  const contractorId = contractorIdPath && !Number.isNaN(Number(contractorIdPath))
    ? Number(contractorIdPath)
    : undefined;
  const { useGetContractorQuery } = contractorService;
  const { currentData: contractor } = useGetContractorQuery(contractorId ?? 0, {
    skip: !contractorId,
  });
  const getBreadcrumbLabel = (path: string, index: number) => {
    if (index === contractorIdPathIndex && contractor?.name) return `${path} (${contractor.name})`;
    if (!Number.isNaN(Number(path))) return path;
    return t(`breadcrumb.${camelCase(path)}`);
  };

  const breadcrumbPath = map(paths, (path: string, index: number) => (
    <Breadcrumb.Item key={`${path}-${index}`}>
      {getBreadcrumbLabel(path, index)}
    </Breadcrumb.Item>
  ));
  return (
    <Breadcrumb className="my-4 mx-0 text-xs">
      <Breadcrumb.Item>Ksec</Breadcrumb.Item>
      {breadcrumbPath}
    </Breadcrumb>
  );
};

export default BreadCrumb;
